import React from 'react'

const Certified = () => {
  return (
    <>

<div className='get-certified'>
    <div className='certification'>
      <h1>Kickstart your career</h1>
       <h1 id='move'>Get certified by completing a course</h1>
   </div>
   <button className='start-btn'>Get Started</button>
   

  
   </div>
    </>
  );
}

export default Certified;